import { useEffect, useState } from "react"
import { Form, Data, FormField, ModalId, useUIActions, FieldType, O, FieldValue, useUIState } from "../../../../../features/ui"
import { validatePhone } from "../../../../../features/data-types"

type Props = {
    contactData?: Data
    onSubmit: (data: Data) => void
}

export const ContactForm = (props: Props) => {
    const { contactData, onSubmit } = props
    const createMode = !contactData

    const [name, setName] = useState<O<string>>(contactData?.contactName as O<string>)
    const [phone, setPhone] = useState<O<number>>(contactData?.contactPhone as O<number>)
    const [focusName, setFocusName] = useState(false)

    const { openedModal } = useUIState()
    const { closeModal } = useUIActions()

    useEffect(() => {
        setTimeout(() => setFocusName(openedModal === ModalId.CONTACT_FORM), 500)
    }, [openedModal])

    const onChangeName = (value?: FieldValue) => setName(value as O<string>)
    const onChangePhone = (value?: FieldValue) => setPhone(value as O<number>)

    const fields: FormField[] = [
        {
            name: 'name',
            type: FieldType.TEXT,
            defaultValue: name,
            label: 'Nombre',
            optional: true,
            focus: focusName,
            onChange: onChangeName
        },
        {
            name: 'phone',
            type: FieldType.NUMBER,
            defaultValue: phone,
            label: 'Teléfono',
            optional: true,
            validate: validatePhone,
            onChange: onChangePhone
        }
    ]

    const handleSubmit = (data: Data) => {
        const newData: Data = {
            contactName: data.name as O<string>,
            contactPhone: data.phone as O<number>
        }
        onSubmit(newData)
        closeModal(ModalId.CONTACT_FORM)
    }

    const handleCancel = () => closeModal(ModalId.CONTACT_FORM)

    return (
        <Form
            formId="contact-form"
            fields={fields}
            createMode={createMode}
            createLabel="Agregar"
            onSubmit={handleSubmit}
            onCancel={handleCancel}
        />
    )
}
